import { useState } from "react";
import { Check, Pencil } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

export function ImportCategoryHeader({ c, all, some, onToggle, exists, onRename }) {
  const [name, setName] = useState(null);
  const save = () => { if (name.trim()) { onRename(c.key, name.trim()); setName(null); } };
  return (
    <div className="flex items-center gap-2 border-b bg-muted/40 px-3 py-2">
      <Checkbox checked={all ? true : some ? "indeterminate" : false} onCheckedChange={(v) => onToggle(!!v)} className="mr-1" data-testid={`menu-import-cat-check-${c.key}`} />
      {name === null ? (
        <>
          <span className="min-w-0 truncate font-semibold" data-testid={`menu-import-cat-name-${c.key}`}>{c.name}</span>
          <Button variant="ghost" size="icon" className="h-7 w-7 shrink-0" onClick={() => setName(c.name)} title="Renomear categoria" data-testid={`menu-import-cat-rename-${c.key}`}><Pencil className="h-3.5 w-3.5" /></Button>
          <span className="flex-1" />
        </>
      ) : (
        <>
          <Input autoFocus value={name} maxLength={60} onChange={(e) => setName(e.target.value)} className="h-8 min-w-0 flex-1"
            onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setName(null); }} data-testid={`menu-import-cat-name-input-${c.key}`} />
          <Button size="icon" className="h-8 w-8 shrink-0" disabled={!name.trim()} onClick={save} title="Salvar nome" data-testid={`menu-import-cat-rename-save-${c.key}`}><Check className="h-4 w-4" /></Button>
        </>
      )}
      <Badge variant={exists ? "outline" : "secondary"} className="shrink-0" data-testid={`menu-import-cat-status-${c.key}`}>{exists ? "Categoria já existe" : "Nova categoria"}</Badge>
      <span className="hidden shrink-0 text-xs text-muted-foreground sm:inline">{c.items.length} {c.items.length === 1 ? "item" : "itens"}</span>
    </div>
  );
}
